import React from 'react';
import { connect } from 'react-redux';
import _find from 'lodash/find';
import _findLast from 'lodash/findLast';
import _get from 'lodash/get';
import PropTypes from 'prop-types';
// Custom
import { asyncOperationDataShape } from 'constants/PropTypesShapes';
import { ASYNC_OP_STATUS_PENDING } from 'constants/App';
import { TriggerIconButton } from 'components/buttons/IconButtons';

const CustomerRightTriggerButtonContent = React.memo(({ loading, onClick }) => (
  <TriggerIconButton
    loading={loading}
    onClick={onClick}
  />
));

CustomerRightTriggerButtonContent.displayName = 'CustomerRightTriggerButtonContent';

CustomerRightTriggerButtonContent.propTypes = {
  loading: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

const CustomerRightTriggerButton = ({ installationTrigger, asyncOperations, onTrigger }) => {
  // Try to find async operation associated (installationTrigger may be null)
  const asyncOperation = _find(asyncOperations, ['id', _get(installationTrigger, 'asyncOperationId')]);

  // Component props
  const compProps = {
    loading: _get(asyncOperation, 'status') === ASYNC_OP_STATUS_PENDING,
    onClick: onTrigger,
  };

  return (
    <CustomerRightTriggerButtonContent {...compProps} />
  );
};

CustomerRightTriggerButton.propTypes = {
  id: PropTypes.number.isRequired, // eslint-disable-line react/no-unused-prop-types
  installationTrigger: PropTypes.shape({
    resource: PropTypes.shape({
      id: PropTypes.number.isRequired,
      type: PropTypes.string.isRequired,
    }),
    asyncOperationId: PropTypes.number,
  }),
  asyncOperations: PropTypes.arrayOf(asyncOperationDataShape).isRequired,
  onTrigger: PropTypes.func.isRequired,
};

CustomerRightTriggerButton.defaultProps = {
  installationTrigger: null,
};

const mapStateToProps = (state, ownProps) => ({
  installationTrigger: _findLast(state.installationTrigger.list, (installationTrigger) => (
    _get(installationTrigger, 'resource.type') === 'right' && _get(installationTrigger, 'resource.id') === ownProps.id)),
  asyncOperations: state.asyncOperation.list,
});

module.exports = connect(
  mapStateToProps,
  null,
)(CustomerRightTriggerButton);



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/customers/CustomerRightTriggerButton.js